module.exports = __webpack_public_path__ + "media/smart_sales/shield-660e2ccd.webp";